export enum PaymentMode {
  ON_ORDER = 'on_order',
  DIFFERED = 'differed',
}
